import classNames from 'classnames';
import React, { useEffect, useRef } from 'react';
import ThronIntegrationComponent from './../../scripts/components/thronIntegrationComponent';
const ThronAudio = (props) => {
    const audioRef = useRef();
    useEffect(() => {
        if (audioRef.current) {
            const playerInstance = new ThronIntegrationComponent(audioRef.current, 'audio');
            props.onPauseCallback && (playerInstance.onPauseCallback = props.onPauseCallback);
            props.onPlayCallback && (playerInstance.onPlayCallback = props.onPlayCallback);
            props.onCompleteCallback && (playerInstance.onCompleteCallback = props.onCompleteCallback);
            props.onInitCallback && (playerInstance.onInitCallback = props.onInitCallback);
            props.onTimeUpdate && (playerInstance.onTimeUpdate = props.onTimeUpdate);
            props.onContentReady && (playerInstance.onContentReady = props.onContentReady);
            typeof props.loopTimes === 'number' && (playerInstance.loopTimes = props.loopTimes);
        }
    }, [props.thronID]);
    return (React.createElement("div", { ref: audioRef, "aria-hidden": "true", className: classNames('audio-wrapper', props.className), "data-option-id": props.thronID, "data-option-mobile-id": props === null || props === void 0 ? void 0 : props.thronMobileID, "data-option-muted": props.muted, "data-option-autoplay": props.autoplay, "data-option-loop": props.loop, "data-option-lock-bitrate": props.lockBitrate, "data-option-no-skin": props.noskin, "data-option-sess-id": props.sessionId }));
};
export default ThronAudio;
